import { COLOR_PALETTE } from 'constants/ui';
import { getScrollStyles } from 'styles/scrollbar.styles';

export const getWrapperStyles = theme => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  flex: 1,
  padding: '24px',
  height: '100%',
  overflow: 'auto',
  ...getScrollStyles(theme).scroll,
});

export const titleWrapperStyles = {
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
};

export const titleStyles = {
  color: ({ palette }) => palette.text.primary,
  fontSize: '1.6rem',
  fontWeight: 700,
  lineHeight: '2.4rem',
};

export const iconWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  aspectRatio: 1,
  height: '20px',
  borderRadius: '50%',
  backgroundColor: COLOR_PALETTE.BLUE[2],
};
